
define('text!templates/modules/questionnaire/responses/answers/answer-info-section.html',[],function () { return '<div class="info-section">\n    <h4>\n        {{question}}\n    </h4>\n    <div class="form-section">\n        <div class="question-answer">{{#answer}} {{.}} {{/answer}} {{^answer}} {{#t}}questionnaire:No answer{{/t}} {{/answer}}</div>\n    </div>\n</div>\n';});

